import {CSSProperties, useContext} from 'react'


interface iProps {content:any , maxWidth?:string ,isPc:boolean ,isMobile:boolean }


export function CellContainer (props:iProps) {
 
let common_style:CSSProperties | undefined={
  fontSize: props.isPc ?'1rem' :props.isMobile?'0.5rem': '0.7rem',
  maxHeight:'50px',
  maxWidth:props.maxWidth?props.maxWidth:props.isPc?'120px': 'fit-content',
  textOverflow:'ellipsis',
  overflow:'hidden',
  textAlign:'center'

}



    return (
        <td
        
        style={props.content&&
          props.content.length>30?
          
        
          {
           ...common_style,
            whiteSpace:'normal',
           
         
          
        
            overflow:'hidden'
          }  :{ ...common_style, whiteSpace: 'nowrap' }
        }>
        { props.content&& props.content.length>30? 
        props.content.slice(0,20)+"...":props.content
        
        }
      </td>
    )
}